import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Modal, Spin } from 'antd';
import { UserOutlined, LockOutlined, UnlockOutlined, MailOutlined } from '@ant-design/icons';
import logo from '../../assets/SMYO_logo-31.png'
import api from '../../services/api'
import styles from '../../services/styles'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { displayMessage } from '../../services/helper';
import RecoverPassword from '../../components/modals/RecoverPassword'
import { SL_CountrySelector } from '../../components/selects/SL_CountrySelector';

const { tc1, tc2, bc1, bc2 } = styles

const Login = () => {

    const {
        setLoggedUser,
        mobile_mode,
        setUser,
        setEnums,
        setShowLoading,
        show_loading,
        selectedLanguage,
        handleSetSelectedLanguage
    } = useContext(GeneralContext)

    const [errorLogin, setErrorLogin] = useState(null);

    const [isModalRecuperarSenhaVisible, setIsModalRecuperarSenhaVisible] = useState(false)
    const [isModal2FAVisible, setIsModal2FAVisible] = useState(false)

    const [email, setEmail] = useState(null)
    const [token2FA, setToken2FA] = useState(null)

    const navigate = useNavigate()

    useEffect(()=>{loadLanguages()},[])

    const loadLanguages = async () => {
        setShowLoading(true)
        try {
            const enums = await api.auth.getEnums()
            setEnums(enums.data)

            let storedCountryCode = localStorage.getItem("language")
            if (!storedCountryCode) {
                await fetch("https://ipapi.co/json/")
                .then(response => response.json())
                .then(data => {
                    const { languages } = data;
                    
                    let code = enums.data?.ECountries.BR.code;
                    if (languages.includes("pt")) {
                      code = enums.data?.ECountries.BR.code
                    } else if (languages.includes("en")) {
                      code = enums.data?.ECountries.EN.code
                    } else if (languages.includes("es")) {
                      code = enums.data?.ECountries.ES.code
                    } else if (languages.includes("fr")) {
                        code = enums.data?.ECountries.FR.code
                      }
                    localStorage.setItem("language", code)
                    handleSetSelectedLanguage(code)
                })
                .catch(error => {
                    console.error("Error fetching country info:", error);
                    const defaultCountryCode = 1
                    localStorage.setItem("language", defaultCountryCode)
                    handleSetSelectedLanguage(defaultCountryCode)
                    window.location.reload()
                })
            }
            else {
                handleSetSelectedLanguage(storedCountryCode)
            }            
        } catch (error) {            
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const onFinish = async (values) => {
        setShowLoading(true)
        try {
            const rs = await api.auth.simpleLogin({...values, lenguage_code: selectedLanguage})
            const {token, user } = rs?.data

            const formattedToken = 'Bearer ' + token
            api.auth.setAuthorizationToken(formattedToken)
            localStorage.setItem('user', JSON.stringify(user))
            localStorage.setItem('language', user?.lenguage_code)
            handleSetSelectedLanguage(user?.lenguage_code)

            setUser(user)
            setLoggedUser(true)
            
            if (user?.must_change_password) {
                navigate('/changePassword')
            } else{
                navigate('/')
            }
        } catch (e) {
            setErrorLogin(e?.response?.data?.error ? e?.response?.data?.error : displayMessage('INVALID_LOGIN'))
        } finally {
            setShowLoading(false)
        }
    }

    const handleOkPasswordRecovery = () => {
        if (!email) {
            alert(displayMessage('INVALID_EMAIL'), 'error')
            return
        }

        setShowLoading(true)

        api.auth.forgotPassword(email)
            .then(
                rs => {
                    if (rs.status == 200) {
                        alert(displayMessage('FORGOT_PASSWORD_SUCCESS'), 'success')
                    }
                    handleCloseModalRecuperarSenha()
                }
            ).finally(() => {
                setShowLoading(false)
            })
    }

    const handleOnValidate2FAToken = async () => {

        try {
            const rs = await api.auth.twoFactorLogin({ email, token_2FA: token2FA })

            const {token, user} = rs?.data
            const formattedToken = 'Bearer ' + token

            api.auth.setAuthorizationToken(formattedToken)
            if (user) {
                localStorage.setItem('user', JSON.stringify(user))
            } else {
                api.auth.removeAuthorizationToken()
            }

            setLoggedUser(true)
            navigate('/', { replace: true })

        } catch (err) {
            console.error(displayMessage('INVALID_TOKEN'), err)
        }
    }

    const handleCloseModalRecuperarSenha = () => {
        setIsModalRecuperarSenhaVisible(false)
        setEmail(null)
    }

    const handleCloseModal2FA = () => {
        setIsModal2FAVisible(false)
    }

    const renderModal2FA = () => {
        return (
            <>
                <Modal
                    title={displayMessage('TWO_FACTOR_AUTH_MODAL_TITLE')}
                    visible={isModal2FAVisible}
                    onCancel={handleCloseModal2FA}
                    centered={true}
                    footer={null}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
                        {show_loading ?
                            <Spin tip={displayMessage('WAITING')} />
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 10, alignItems: 'center', maxWidth: 350 }}>
                                <div style={{ fontWeight: 'bold', marginRight: 10, alignSelf: 'center', textAlign: 'center' }}>{displayMessage('TWO_FACTOR_AUTH_SENT_MESSAGE')}</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <MailOutlined style={{ fontSize: 55 }} />
                                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                                        <span style={{ fontSize: 14 }}>{displayMessage('DISPLAY_2FA_CODE')} </span>
                                        <Input
                                            type="text"
                                            style={{ width: '100%', height: 30 }}
                                            value={token2FA}
                                            required={true}
                                            onChange={
                                                e => {
                                                    setToken2FA(e.target.value)
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                                <Button onClick={handleOnValidate2FAToken} style={{ width: '100%' }} type="primary"> {displayMessage('VERIFY')} </Button>
                            </div>
                        }
                    </div>
                </Modal>
            </>
        )

    }

    return (
        <>
            {isModalRecuperarSenhaVisible && 
                <RecoverPassword
                    isModalRecoverPasswordOpen={isModalRecuperarSenhaVisible}
                    handleOnCloseModalRecoverPassword={handleCloseModalRecuperarSenha}
                    handleOnOkRecoverPassword={handleOkPasswordRecovery}
                    email={email}
                    setEmail={setEmail}
                />
            }

            {isModal2FAVisible && renderModal2FA()}

            <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ height: '100%', background: bc1, display: mobile_mode ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', flex: 2 }}>
                    <img
                        src={logo}
                        style={{ width: '70%', minWidth: 300 }}
                    />
                </div>

                <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, minWidth: mobile_mode ? 350 : 450 }}>
                    <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, justifyContent: 'center' }}>
                            <div style={{ color: tc1, fontWeight: 'bold', marginBottom: 15, fontSize: mobile_mode ? 20 : 24 }}>{displayMessage("MAYOPLAY_PANEL")}</div>

                            <Form
                                name="normal_login"
                                initialValues={{ remember: true }}
                                labelCol={{ span: 25 }}
                                wrapperCol={{ span: 80 }}
                                onFinish={onFinish}
                    
                            >
                                <Form.Item
                                    name="email"
                                    rules={[{ required: true, message: displayMessage('DISPLAY_EMAIL') }]}
                                >
                                    <Input style={{ width: '100%' }} prefix={<UserOutlined className="site-form-item-icon" />} placeholder={displayMessage('EMAIL')} />
                                </Form.Item>

                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: displayMessage('DISPLAY_PASSWORD') }]}
                                >
                                    <div>
                                        <Input
                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                            type="password"
                                            placeholder={displayMessage("PASSWORD")}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item hasFeedback style={{ marginBottom: 10 }}>
                                    <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                                        {displayMessage("ENTER")}
                                    </Button>
                                </Form.Item>

                                <div className='flex justify-between gap-7'>
                                    <Form.Item>
                                        <div className='flex justify-center text-center'>
                                            <Link to='' onClick={() => { setIsModalRecuperarSenhaVisible(true); setEmail(null) }} >{displayMessage('RECOVER_PASSWORD')}</Link>
                                        </div>
                                    </Form.Item>
                                    <Form.Item>
                                        <div className='flex justify-center text-center'>
                                            <Link to='patient'>{displayMessage('PATIENT_LOGIN')}</Link>
                                        </div>
                                    </Form.Item>
                                </div>
                            </Form>
                        </div>
                        <div className='flex f-1 w-full p-2 justify-end'>
                            <SL_CountrySelector isLogin={true}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;